import { useCallback, useEffect, useMemo, useState } from "react";
import { genericGet } from "services/services.general";
import { getFormattedOptions } from "utility/helpers";

const useCommittees = () => {
  const [committees, setCommittees] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const refetch = useCallback(() => {
    setIsLoading(true);

    genericGet({
      url: "/committee",
      callback: (data) => {
        setCommittees(data);
        setIsLoading(false);
      },
    });
  }, []);

  const options = useMemo(() => {
    return getFormattedOptions("name", committees);
  }, [committees]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return {
    data: committees,
    isLoading,
    refetch,
    options,
  };
};

export default useCommittees;
